

















import {Component, Prop, Vue} from "vue-property-decorator";
import {mapGetters} from "vuex";

import MemberCard from "@/components/community/_memberCard.vue";
import {User} from "@/types";
import FollowBtn from "@/components/user/_followBtn.vue";
import {AxiosError, AxiosResponse} from "axios";
import MetaSetting from "@/script/metaSetting";

@Component({
    computed: {...mapGetters(["user"])},
    components: {MemberCard, FollowBtn},
})
export default class MemberList extends Vue {
    metaSetting !: MetaSetting;
    communityId = this.$route.params.community_id;
    totalMembers: number = 0;
    memberList: User[] = [];
    user!: User;
    limit: number = 10;
    offset: number = 0;

    mounted() {
        this.fetch();
    }

    fetch() {
        const obj = {
            limit: this.limit,
            offset: this.offset
        }
        this.$api.communityMembers(this.communityId, obj)
            .then((res: any) => {
                this.totalMembers = res.totalCount;
                this.memberList = res.result;
            })
            .catch((err: AxiosError) => {

            })


    }



    reFetch(){
        this.limit = 10;
        this.offset = 0;
        this.memberList = [];
        this.$store.dispatch('reloadUserInfo');
        this.fetch();

    }


}
